<template>
  <div>
    <v-row class="headline align-center border-b--thin pa-8">
      Reminders
    </v-row>

    <v-card  outlined class="backgroundCard ma-4 pa-2">
      Reminders are private and only your account can see them
    </v-card>

    <div class="pa-2">
      <tree-view></tree-view>
    </div>
  </div>
</template>

<script>
import TreeView from './tree/main'

export default {
  components: {
    TreeView
  }
}
</script>